(function ($, root, undefined) {

  $(function () {

    'use strict';

    // START WRITING FUNCTIONS (jQuery is enabled in this section)


    function mediaSize() {
      if (window.matchMedia('(min-width: 1021px)').matches) {
        //page transition
        if ($('.animsition').length) {
          $(".animsition").animsition({
            inClass: 'fade-in',
            outClass: 'fade-out',
            inDuration: 1000,
            outDuration: 1000,
            linkElement: '#',
            /* .animsition-lin */
            // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
            loading: true,
            loadingParentElement: 'body', //animsition wrapper element
            loadingClass: 'animsition-loading',
            loadingInner: '', // e.g '<img src="loading.svg" />'
            timeout: false,
            timeoutCountdown: 5000,
            onLoadEvent: true,
            browser: ['animation-duration', '-webkit-animation-duration'],
            // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
            // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
            overlay: false,
            overlayClass: 'animsition-overlay-slide',
            overlayParentElement: 'body',
            transition: function (url) {
              window.location.href = url;
            }
          });

          $('.home .animsition').animsition({
            inDelay: 2000,
            inDuration: 2000,
            onLoadEvent: false,
            timeout: true,
            timeoutCountdown: 2000
          });
        }
      }
      // if (window.matchMedia('(min-width: 861px)').matches) {
      //   // When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar
      //   var prevScrollpos = window.pageYOffset;
      //   window.onscroll = function () {
      //     var currentScrollPos = window.pageYOffset;
      //     if ($('.promo-banner').length) {
      //       var promoBannerHeight = $('.promo-banner').outerHeight();
      //       if (prevScrollpos > currentScrollPos) {
      //         $('header').removeClass('scrolled')
      //         $('.navbar').css({
      //           'opacity': 1,
      //           'background-color': '#fff'
      //         });
      //         $('.mobile .menu').css({
      //           'position': 'fixed',
      //           'top': promoBannerHeight + 2
      //         })
      //       } else if ($(this).scrollTop() > 150) {
      //         $('header').addClass('scrolled')
      //         $('.navbar').css({
      //           'background-color': '#fff'
      //         });
      //         $('.mobile .menu').css({
      //           'position': 'fixed',
      //           'top': '-70px'
      //         })
      //       }
      //     } else {
      //       if (prevScrollpos > currentScrollPos) {
      //         $('header').removeClass('scrolled')
      //         $('.navbar').css({
      //           'background-color': '#fff'
      //         });
      //         if ($('.home #v2').length) {
      //           $('.mobile .menu').css({
      //             'position': 'fixed',
      //             'top': '8px'
      //           })
      //         } else {
      //           $('.mobile .menu').css('top', '8px');
      //         }
      //       } else if ($(this).scrollTop() > 150) {
      //         $('header').addClass('scrolled')
      //         $('.navbar').css({
      //           'background-color': '#fff'
      //         });
      //         if ($('.home #v2').length) {
      //           $('.mobile .menu').css({
      //             'position': 'fixed',
      //             'top': '-70px'
      //           })
      //         } else {
      //           $('.mobile .menu').css('top', '-70px');
      //         }
      //       }
      //     }
      //     prevScrollpos = currentScrollPos;

      //   }
      //   //               if($('.promo-banner').length){
      //   //                 var promoBannerHeight = $('.promo-banner').outerHeight();
      //   //                 $('.navbar').css('top', promoBannerHeight);
      //   //                 $('.promo-banner').css('top', 0);
      //   //               }              
      // } else {
      //   if ($('.promo-banner').length) {
      //     var promoBannerHeight = $('.promo-banner').outerHeight();
      //   }
      //   window.onscroll = function () {
      //     $('.navbar').css({
      //       'background-color': '#fff'
      //     });
      //   }
      // }
    }
    mediaSize();
    window.addEventListener('resize', mediaSize, false);

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('.the-lineup__tabs-tab-link')
      .not('.our-story-our-promise__tab-link')
      .not('.discover-our-lineup__tab-link')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 750)
            if ($('.nav_dropdown').length) {
              $('.nav_dropdown').hide()
            }
          }
        }
      });

    //custom home page preloader 
    /*
    $(window).on("load", function () {
      setTimeout(function () {
        $('.home .preloader').addClass('hidden');
        $('.home .home-overlay').addClass('hidden');
        //                 if($('.promo-banner').length){
        //                   $('.promo-banner').removeClass('hidden');
        //                 }             
      }, 1500);
    });
    */

    if ($('.promo-banner').length) {
      // $(window).load(function () {
      //   $(".mobile nav").css({
      //     'top': $(".promo-banner").outerHeight(true) + 60
      //   })
      //   if (typeof (Storage) !== "undefined") {
      //     if (sessionStorage.redClayShowPromo != 1) {
      //       $("header").css("top", -$('.promo-banner').outerHeight(true));
      //       if ($('.body.home').length) {
      //         $('.promo-banner').hide()
      //         $('.promo-banner').addClass('hidden');
      //         $(".mobile nav").css({
      //           'top': '60px'
      //         })
      //         setTimeout(function () {
      //           $('.promo-banner').show(0);
      //           $('.promo-banner').removeClass('hidden');
      //           $(".mobile nav").css({
      //             'top': $(".promo-banner").outerHeight(true) + 60
      //           })
      //         }, 1500)
      //       } else {
      //         $('.promo-banner').show(0);
      //         $('.promo-banner').removeClass('hidden');
      //         if ($(window).width() < 1021 && $("#product").length) {
      //           //                     $('#product .hero a.return').css({
      //           //                       top: $('.navbar').height() + $(".promo-banner").height()
      //           //                     })                    
      //         }
      //       }
      //     } else {
      //       $('.promo-banner').addClass('hidden');
      //       $(".mobile nav").css({
      //         'top': '60px'
      //       })
      //       if ($(window).width() < 1021 && $("#product").length) {
      //         //                     $('#product .hero a.return').css({
      //         //                       top: '15px'
      //         //                     })                    
      //       }
      //     }
      //   }
      // });

      $('.promo-banner').click(function (e) {
        e.preventDefault();
        // $('.promo-banner').fadeOut(300, function () {
        //   $(".mobile nav").css({
        //     'top': '60px'
        //   })
        //   if (typeof (Storage) !== "undefined") {
        //     sessionStorage.redClayShowPromo = 1;
        //   }
        //   $('.promo-banner').addClass('hidden');
        //   $('header').css('top', '0');
        //   if ($(window).width() < 1021 && $("#product").length) {
        //     //                 $('#product .hero a.return').css({
        //     //                   top: '15px'
        //     //                 })                    
        //   }
        // });
      });

    } else {
      $('header.navbar').css('top', '0');
    }

    //menu
    var isActive = false;
    $('.js-menu').on('click', function () {
      $(".nav_sub_menu").slideUp();
      $('li.has_sub_menu').removeClass('active');
      if (isActive) {
        $(this).removeClass('active');
        $('body').removeClass('menu-open');
      } else {
        $(this).addClass('active');
        $('body').addClass('menu-open');
      }

      isActive = !isActive;
    });
    if ($(".nav_sub_menu").length) {
      $(".nav_sub_menu").hide();
      $(".has_sub_menu > span").on("click", function () {
        var shopToggle = $(this);
        if (isActive) {
          shopToggle.parent('.has_sub_menu').toggleClass('active');
          shopToggle.siblings(".nav_sub_menu").slideToggle()
        }
      })
      $(".nav_dropdown_link_heading").on("click", function () {
        $(".nav_sub_menu").slideUp();
        $('li.has_sub_menu').removeClass('active');
        $('.js-menu').removeClass('active');
        $('body').removeClass('menu-open');
        isActive = true;

        $('html, body').animate({
          scrollTop: $("main #shopify-section-shop .container").offset().top
        }, 450);

      })
    }

    $('.account .cart').on('click', function () {
      $('.cart-items').addClass('open');
      $('.cart-overlay').addClass('reveal');
      $("html").css("overflow-y", "hidden");
    })

    $('.cart-items .close-btn').on('click', function () {
      $('.cart-items').removeClass('open');
      $('.cart-overlay').removeClass('reveal');
      $("html").css("overflow-y", "auto");
    })

    //close cart by clicking outside
    var $cart = $('.cart');
    var $cartItems = $('.cart-items');
    var $cartOverlay = $('.cart-overlay');
    $(document).click(function (e) {
      if (!$cart.is(e.target) && $cart.has(e.target).length === 0) {
        $cartItems.removeClass('open');
        $cartOverlay.removeClass('reveal');
        $("html").css("overflow-y", "auto");
      }
    });

    //promo popup
    var promoShow = localStorage.getItem('promoShow');
    if ($('.promo-popup').length) {
      if (promoShow == null) {
        setTimeout(function () {
          localStorage.setItem('promoShow', 1);
          $('.promo-overlay').addClass('show');
          $('.promo-popup').addClass('show');
        }, 12000)
      }
    }
    $('.promo-popup .popup-close').click(function () {
      $('.promo-overlay').removeClass('show');
      $('.promo-popup').removeClass('show');
    });
    $('.promo-popup form').on('submit', function () {
      setTimeout(function () {
        $('.promo-popup .popup-content form input[type="email"]').fadeOut();
        $('.promo-popup .popup-content form input[type="submit"]').fadeOut();
      }, 300)
    })


    // when a user highlights over a list, change the image next to it (i.e. homepage)
    if ($('.home').length) {
      $('.home .two-column ul li').hover(
        function () {
          var newImage = $(this).find('img').attr('src');
          $(this).parents('section').find('.img').css('background', `url('${newImage}')`);
        }
        //             function() {
        //                 var originalImage = $(this).parent().children('li').first().find('img').attr('src');
        //                 $(this).parents('section').find('.img').css('background', `url('${originalImage}')`);
        //             }
      );
      $('body.home main .two-column ul li').mouseenter(function () {
        $('body.home main .two-column ul li').css("color", "var(--base-black)")
        $(this).css("color", "var(--base-red)");
      })
      if ($('.press').length) {
        $('.slider').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          autoplay: false,
          responsive: [{
              breakpoint: 1020,
              settings: {
                slidesToShow: 3,
                dots: true
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                dots: true
              }
            }
          ]
        })
      }
      //accordion
      if ($('.accordion').length) {
        $(".item > .title").on("click", function () {
          var activeImageSrc = $(this).parent().find('img').attr('src');
          $('.highlights .image').css('background', 'url(' + activeImageSrc + ')');
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".bodytext").slideUp(200);
            $(".item > .title i").removeClass("minus").addClass("plus");
          } else {
            $(".item > .title i").removeClass("minus").addClass("plus");
            $(this).find("i").removeClass("plus").addClass("minus");
            $(".item > .title").removeClass("active");
            $(this).addClass("active");
            $(".accordion .bodytext").slideUp(200);
            $(this).siblings(".bodytext").slideDown(200);
          }
        });
      }
    }

    //show gift wrap when checkbox is checked
    if ($('.cart-items .checkbox input[type=checkbox]').attr('checked')) {
      $(this).parent().next().toggleClass('reveal');
    }
    $('.cart-items .gift-wrap .checkbox label').on('click', function () {
      $(this).parent().next().toggleClass('reveal');
      $('.cart-items').toggleClass('gift-wrap-toggle');
    })
    $('.cart-items .checkbox input[type=checkbox]').change(function () {
      if (this.checked != true) {
        $('.cart-items .gift-wrap .message input').val('');
        var notes = '';
        cartNotes(notes);
        updateGiftWrappingFee(0);
      } else {
        updateGiftWrappingFee(1);
      }
    });
    $('.cart-items .gift-wrap .message input').on('input', function () {
      var notes = $('.cart-items .gift-wrap .message input').val();
      cartNotes(notes);
    });

    // shop tab filtering 
    if ($('.shop').length) {
      $('.shop a.category').click(function () {
        $('.shop .product-item').hide();
        $('.shop a.category').removeClass('active');
        $(this).addClass('active');
        var filter = $(this).attr('data-category');
        //console.log($(this).attr('data-category'));
        filterList(filter);
      });

      $('.shop .shop-categories select').on('change', function () {
        filterList(this.value);
      })

      $(window).on('hashchange', function () {
        var hash = window.location.hash;
        $('.shop a.category').removeClass('active');
        filterList(hash.replace('#', ''));
        $(".shop a[href='" + hash + "']").addClass('active');
        $('html, body').animate({
          scrollTop: $("main #shopify-section-shop .container").offset().top
        }, 450);
      });

      if (window.location.hash) {
        var hash = window.location.hash;
        $('.shop a.category').removeClass('active');
        $('html, body').animate({
          scrollTop: $("main #shopify-section-shop .container").offset().top
        }, 450);
        filterList(hash.replace('#', ''));
        $(".shop a[href='" + hash + "']").addClass('active');
      }

      //shop filter function
      function filterList(value) {
        var list = $(".shop .products .product-item");
        $(".nav_sub_menu").slideUp();
        $('li.has_sub_menu').removeClass('active');
        $('.js-menu').removeClass('active');
        $('body').removeClass('menu-open');
        isActive = true;
        $(list).hide();
        $(list).parent().prev().hide()
        if (value == "everything") {
          $(".shop .products").find(".product-item").each(function (i) {
            if ($(window).width() > 1020) {
              $(this).parent().prev().show().css('padding-top', '90px')
            } else {
              $(this).parent().prev().show().css('padding-top', '35px')
            }
            $(this).show();
          });
        } else {
          $(".shop .products").find(".product-item[data-category*=" + value + "]").each(function (i) {
            $(this).parent().prev().show().css('padding-top', 0)
            $(this).show();
          });
        }
      }
    }

    // admin input label toggling 
    $('.admin main .content form input').on('input', function () {
      if ($(this).val() == '') {
        $(this).prev().removeClass('visible');
      } else {
        $(this).prev().addClass('visible');
      }
    });

    // Dropdown toggle
    $('.single-product .dropdown-group .dropdown-toggle:not(.nutrition_toggle)').click(function () {
      var $this = $(this);
      $this.toggleClass('open')
      $(this).next('.dropdown, p').toggleClass('open');
      $this.next().slideToggle();
    });

    if ($('.nutrition_toggle').length) {
      $('.nutrition_toggle').on('click', function () {
        $('.nutrition_lightbox').fadeIn()
        $('html, body').css('overflow', 'hidden')
        $('main').css('z-index', '1000')
      })
      $('.nutrition_lightbox_overlay').on('click', function () {
        $('.nutrition_lightbox').fadeOut()
        $('html, body').css('overflow', 'visible')
        $("main").css("z-index", "9");
      })
    }

    // landing page slider
    if ($('.landing').length) {
      $('.slider').slick({
        dots: true
      });
    }

    //removes hover on mobile/tablet devices 
    function hasTouch() {
      return 'ontouchstart' in document.documentElement ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0;
    }
    if (hasTouch()) { // remove all :hover stylesheets
      try { // prevent exception on browsers not supporting DOM styleSheets properly
        for (var si in document.styleSheets) {
          var styleSheet = document.styleSheets[si];
          if (!styleSheet.rules) continue;

          for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
            if (!styleSheet.rules[ri].selectorText) continue;

            if (styleSheet.rules[ri].selectorText.match(':hover')) {
              styleSheet.deleteRule(ri);
            }
          }
        }
      } catch (ex) {}
    }

    // STOP WRITING FUNCTIONS   


  });


})(jQuery, this);